import React, { useEffect, useMemo, useState } from "react";

const COLORS = [
  "#ef4444",
  "#f59e0b",
  "#22c55e",
  "#3b82f6",
  "#a855f7",
  "#ec4899",
];

const BirthdayConfettiOverlay = ({ userName = "Friend" }) => {
  const [visible, setVisible] = useState(true);

  const pieces = useMemo(() => {
    return Array.from({ length: 90 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 2.5}s`,
      duration: `${4 + Math.random() * 3}s`,
      rotate: Math.floor(Math.random() * 360),
      width: 10 + Math.floor(Math.random() * 14),
      height: 14 + Math.floor(Math.random() * 20),
      color: COLORS[i % COLORS.length],
      opacity: 0.9,
    }));
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setVisible(false);
      },
      2 * 60 * 1000,
    ); // 2 minutes

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes confettiDrop {
          0% {
            transform: translateY(-120px) rotate(0deg);
            opacity: 0;
          }
          8% {
            opacity: 1;
          }
          100% {
            transform: translateY(110vh) rotate(720deg);
            opacity: 1;
          }
        }

        @keyframes balloonFloat {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }

        @keyframes titleGlow {
          0% { transform: translateX(-50%) scale(1); }
          50% { transform: translateX(-50%) scale(1.03); }
          100% { transform: translateX(-50%) scale(1); }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        {pieces.map((p) => (
          <span
            key={p.id}
            style={{
              position: "absolute",
              top: "-40px",
              left: p.left,
              width: p.width,
              height: p.height,
              background: p.color,
              borderRadius: 3,
              transform: `rotate(${p.rotate}deg)`,
              opacity: p.opacity,
              animation: `confettiDrop ${p.duration} linear infinite`,
              animationDelay: p.delay,
              boxShadow: "0 6px 12px rgba(0,0,0,0.12)",
            }}
          />
        ))}

        <div
          style={{
            position: "absolute",
            top: 18,
            left: 28,
            width: 56,
            height: 78,
            borderRadius: "50% 50% 46% 46%",
            background: "rgba(147,197,253,0.82)",
            boxShadow: "inset -8px -10px 14px rgba(255,255,255,0.35)",
            animation: "balloonFloat 3s ease-in-out infinite",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: -40,
              left: "50%",
              width: 1,
              height: 42,
              background: "#6b7280",
            }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            top: 26,
            right: 36,
            width: 60,
            height: 82,
            borderRadius: "50% 50% 46% 46%",
            background: "rgba(253,186,116,0.82)",
            boxShadow: "inset -8px -10px 14px rgba(255,255,255,0.35)",
            animation: "balloonFloat 3.4s ease-in-out infinite",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: -42,
              left: "50%",
              width: 1,
              height: 44,
              background: "#6b7280",
            }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            top: 18,
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            animation: "titleGlow 2.6s ease-in-out infinite",
          }}
        >
          <div
            style={{
              fontSize: 18,
              marginBottom: 2,
            }}
          >
            🎉🎉🎉
          </div>

          <div
            style={{
              fontSize: 28,
              fontWeight: 800,
              color: "#9d174d",
              textShadow: "0 2px 10px rgba(255,255,255,0.7)",
              lineHeight: 1.1,
            }}
          ></div>

          <div
            style={{
              fontSize: 20,
              marginTop: 4,
            }}
          >
            🎂🎂🎂🎂🎂🎂🎂
          </div>
        </div>
      </div>
    </>
  );
};

export default BirthdayConfettiOverlay;
